import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';
import { WpSectionCode, WpClientCode } from '../../../services/http/wordpress/wordpress.interface';
import { WordpressService } from '../../../services/http/wordpress/wordpress.service';

@Component({
  selector: 'app-data-treatment',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './data-treatment.component.html',
  styleUrl: './data-treatment.component.scss'
})
export class DataTreatmentComponent {
  dataTreatmentText = '';
  title = "";
  description = "";
  image = "";

  constructor(
    private readonly wordpressService: WordpressService
  ) {
    this.wordpressService.getPost({section: WpSectionCode.dataTreatment, client: WpClientCode.genCat}).subscribe((response) => {
      this.dataTreatmentText = response?.content.rendered || '';
      this.title = response?.title.rendered || '';
      this.image = response?.acf.image_url || '';
    });
  }
}
